export const ID = 'COURSES_ID'
export const COURSE = 'COURSES_COURSE'
export const COURSE_LOADED = 'COURSES_COURSE_LOADED'
export const LIST = 'COURSES_LIST'
export const PROGRESS = 'COURSES_PROGRESS'
export const LOADING = 'COURSES_LOADING'
export const ON_CHANGE = 'COURSES_ON_CHANGE'
export const ON_CHANGE_QUESTION = 'COURSES_ON_CHANGE_QUESTION'
export const RESET_QUESTION = 'COURSES_RESET_QUESTION'
export const QUESTION_ACTIVE_INDEX = 'COURSES_QUESTION_ACTIVE_INDEX'
export const UNDO = 'COURSES_UNDO'
export const PRESENT = 'COURSES_PRESENT'
export const RESET = 'COURSES_RESET'
export const TOGGLE_UPLOAD_PAGE = 'COURSES_TOGGLE_UPLOAD_PAGE'
export const EDIT_VIDEO = 'COURSES_EDIT_VIDEO'
export const UPLOAD_FILE_STATUS = 'COURSES_UPLOAD_FILE_STATUS'
export const UPLOAD_VIDEO_STATUS = 'COURSES_UPLOAD_VIDEO_STATUS'
export const UPDATE_VIDEO = 'COURSES_UPDATE_VIDEO'
export const ADD_SECTION = 'COURSES_ADD_SECTION'
export const SECTION_ACTIVE_INDEX = 'COURSES_SECTION_ACTIVE_INDEX'
export const EDIT_FILE = 'COURSES_EDIT_FILE'
export const UPDATE_FILE = 'COURSES_UPDATE_FILE'
export const TOGGLE_UPLOAD_FILE_PAGE = 'COURSE_TOGGLE_UPLOAD_FILE_PAGE'
export const COURSE_THUMBNAIL = 'COURSE_THUMBNAIL'
export const COURSE_THUMBNAIL_FILE = 'COURSE_THUMBNAIL_FILE'
export const COURSE_CREATE = 'COURSE_CREATE'
export const VIDEO_UPLOAD_PERCENT = 'VIDEO_UPLOAD_PERCENT'
export const FILE_UPLOAD_PERCENT = 'FILE_UPLOAD_PERCENT'
export const UPDATE_DESCRIPTION = 'CHECKLIST_UPDATE_DESCRIPTION'
export const UPLOAD_SCORM_PERCENT = 'UPLOAD_SCORM_PERCENT'
export const UPLOAD_SCORM_STATUS = 'UPLOAD_SCORM_STATUS'
export const TOGGLE_UPLOAD_SCORM_PAGE = 'TOGGLE_UPLOAD_SCORM_PAGE'
export const EDIT_SCORM = 'EDIT_SCORM'
export const UPDATE_SCORM = 'UPDATE_SCORM'
export const SELECT_VIDEO_TYPE = 'SELECT_VIDEO_TYPE'
export const REORDER_CONTAINERS = 'REORDER_CONTAINERS'
export const SET_CURRENT_TAB = 'COURSES_SET_CURRENT_TAB'
export const SET_CURRENT_TAB_VIEW_COURSE = 'SET_CURRENT_TAB_VIEW_COURSE'
export const SET_TEXT_CONTENT = 'COURSES_SET_TEXT_CONTENT'
export const UPDATE_TEXT = 'COURSES_UPDATE_TEXT'
export const COURSE_ALL = 'COURSES_COURSE_ALL'
export const SET_USER_PROGRESS = 'SET_USER_PROGRESS'
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const SET_TRACKING_DATA = 'SET_TRACKING_DATA'
export const SET_TRACKING_DATA_REWATCH = 'SET_TRACKING_DATA_REWATCH'
export const CONTAINERS_LOADED = 'CONTAINERS_LOADED'
export const SET_CONTENTS = 'COURSES_SET_CONTENTS'
export const SET_CONTENTS_LOADING = 'SET_CONTENTS_LOADING'
export const SET_SUBMISSIONS = 'COURSES_SET_SUBMISSIONS'
export const SLECT_COURSE_GROUPS = 'COURSES_SLECT_GROUPS'
export const REORDER_QUIZZES = 'COURSE_EDIT_QUIZ_ORDER'
export const MANAGE_HTML = 'COURSE_EDIT_MANAGE_HTML'
export const SET_HTML_CONTENT = 'SET_HTML_CONTENT'
export const TOGGLE_QUIZ_RETAKE = 'TOGGLE_QUIZ_RETAKE'
export const TOGGLE_PASS_PERCENTAGE = 'TOGGLE_PASS_PERCENTAGE'
export const TOGGLE_QUIZ_TIMER = 'TOGGLE_QUIZ_TIMER'
export const TOGGLE_QUIZ_RANDOMIZE_ORDER = 'TOGGLE_QUIZ_RANDOMIZE_ORDER'
export const SET_CLONE_ID = 'SET_CLONE_ID'
export const SET_COURSE_LANGUAGE = 'SET_COURSE_LANGUAGE'
export const SET_NEW_TEXT_CONTENT = 'SET_NEW_TEXT_CONTENT'
export const UPDATE_CONTENT = 'UPDATE_CONTENT'
export const SET_REQUIRED_CONTENT = 'SET_REQUIRED_CONTENT'
export const SET_REQUIRED = 'SET_REQUIRED'
export const SET_RESTRICT_VIDEO = 'SET_RESTRICT_VIDEO'
export const SET_FINISHED_CONTENT = 'SET_FINISHED_CONTENT'
export const SET_CONTENT_REQUIRED = 'SET_CONTENT_REQUIRED'
export const SET_STATUSES = 'SET_STATUSES'
export const SET_SELECTED_STATUESES = 'SET_SELECTED_STATUESES'
export const SET_USER_GROUPS = 'SET_USER_GROUPS'
export const SET_USER_GROUPS_COURSES = 'SET_USER_GROUPS_COURSES'
export const SET_GROUP_COURSES_STATUS = 'SET_GROUP_COURSES_STATUS'
export const SET_MANAGEABLE_COURSES = 'SET_MANAGEABLE_COURSES'
export const SET_REDIRECT_URL = 'SET_REDIRECT_URL'
export const SET_CERTIFICATE_FOOTER_CONTENT = 'SET_CERTIFICATE_FOOTER_CONTENT'
export const SET_SHOW_CERTIFICATE = 'SET_SHOW_CERTIFICATE'
export const SET_HIDE_CERTIFICATE = 'SET_HIDE_CERTIFICATE'
export const SET_SHOW_FEEDBACK = 'SET_SHOW_FEEDBACK'
export const SET_RETAKE_QUIZ_COUNT = 'SET_RETAKE_QUIZ_COUNT'
export const SET_TEXT_TITLE = 'SET_TEXT_TITLE'
export const SET_SUBTITLE = 'SET_SUBTITLE'
export const SET_COURSE_AVAILABLE_LANGUAGES = 'SET_COURSE_AVAILABLE_LANGUAGES'
export const SET_AVAILABLE_LANGUAGES_OPTIONS = 'SET_AVAILABLE_LANGUAGES_OPTIONS'
export const SET_LANGUAGE_READY = 'SET_LANGUAGE_READY'
export const SET_QUIZ = 'SET_QUIZ'
export const SET_ALL_COURSES = 'SET_ALL_COURSES'
export const SET_EQUIVALENT_COURSE = 'SET_EQUIVALENT_COURSE'
export const SET_KEYWORDS = 'SET_KEYWORDS'
export const SET_AVAILABLE_KEYWORDS = 'SET_AVAILABLE_KEYWORDS'
export const SET_COURSE_INACTIVE = 'SET_COURSE_INACTIVE'
export const SET_SECOND_LEVEL_APPROVAL = 'SET_SECOND_LEVEL_APPROVAL'
export const SET_CHECKLIST_TYPE = 'SET_CHECKLIST_TYPE'
export const SET_QUIZ_PASS_PERCENTAGE = 'SET_QUIZ_PASS_PERCENTAGE'
export const SET_CURRENT_COURSE = 'SET_CURRENT_COURSE'
export const SELECT_COURSE = 'SELECT_COURSE'
export const SELECT_CONTENT = 'SELECT_CONTENT'
export const SET_ITEMS = 'SET_ITEMS'
export const SET_PAGE_OF_ITEMS = 'SET_PAGE_OF_ITEMS'
export const SET_COURSE_EXISTING_CONTENT = 'SET_COURSE_EXISTING_CONTENT'
export const SET_EXISTING_CONTENT = 'SET_EXISTING_CONTENT'
export const SET_SEARCH_VALUE_EXISTING_CONTENT =
  'SET_SEARCH_VALUE_EXISTING_CONTENT'
export const SET_SHOW_CLAIM_REWARD = 'SET_SHOW_CLAIM_REWARD'
export const SET_HIDE_CLAIM_REWARD = 'SET_HIDE_CLAIM_REWARD'
export const SET_EARNED_REWARDS_BADGES = 'SET_EARNED_REWARDS_BADGES'
export const SET_EARNED_REWARDS_POINTS = 'SET_EARNED_REWARDS_POINTS'
export const SET_LTI_DATA = 'SET_LTI_DATA'
export const SET_LAUNCH_URL = 'SET_LAUNCH_URL'
export const SET_CONSUMER_KEY = 'SET_CONSUMER_KEY'
export const SET_CONSUMER_SECRET = 'SET_CONSUMER_SECRET'
export const SET_CUSTOM_PARAMETERS = 'SET_CUSTOM_PARAMETERS'
export const SET_LTI_PARAMS = 'SET_LTI_PARAMS'
export const RESET_LTI_FIELDS = 'RESET_LTI_FIELDS'
export const SELF_ASSIGNABLE = 'SELF_ASSIGNABLE'
export const DONT_SHOW_ON_MANAGER_REPORT = 'DONT_SHOW_ON_MANAGER_REPORT'
export const SET_SEARCH_VALUE_ON_CLICK = 'SET_SEARCH_VALUE_ON_CLICK'
export const SET_SUSPEND_DATA = 'SET_SUSPEND_DATA'
export const SET_FEEDBACK_DATA = 'SET_FEEDBACK_DATA'
export const SET_RATING_DATA = 'SET_RATING_DATA'
export const SET_HIDE_FEEDBACKRATING = 'SET_HIDE_FEEDBACKRATING'
export const SET_SELF_COURSE_FEEDBACK_DATA = 'SET_SELF_COURSE_FEEDBACK_DATA'
export const SET_COURSE_NOTE = 'SET_COURSE_NOTE'
export const FETCH_COURSE_NOTE = 'FETCH_COURSE_NOTE'
export const TOOGLE_FEEDBACK_OVERLAY = 'TOOGLE_FEEDBACK_OVERLAY'
export const FETCH_COURSE_RATING = 'FETCH_COURSE_RATING'
export const ON_CHANGE_ZOOM = 'ON_CHANGE_ZOOM'
export const START_URL = 'START_URL'
export const JOIN_URL = 'JOIN_URL'
export const SET_FEEDBACK_TEXTBOX_ACTIVE = 'SET_FEEDBACK_TEXTBOX_ACTIVE'
export const SET_COURSE_COMMENT = 'SET_COURSE_COMMENT'
export const SET_COURSE_COMMENTS = 'SET_COURSE_COMMENTS'
export const SET_COURSE_COMMENT_REPLY = 'SET_COURSE_COMMENT_REPLY'
export const ADD_COURSE_COMMENT = 'ADD_COURSE_COMMENT'
export const SET_NEW_COMMENT_ACTIVE = 'SET_NEW_COMMENT_ACTIVE'
export const SET_SEARCH_VALUE_COMMENTS = 'SET_SEARCH_VALUE_COMMENTS'
export const SET_EDIT_TEXTBOX_ACTIVE = 'SET_EDIT_TEXTBOX_ACTIVE'
export const SET_REPLY_TEXTBOX_ACTIVE = 'SET_REPLY_TEXTBOX_ACTIVE'
export const SET_CURRENT_COMMENT = 'SET_CURRENT_COMMENT'
export const SET_LOADING_COMMENTS = 'SET_LOADING_COMMENTS'
export const SET_NEW_COMMENT_DISABLED = 'SET_NEW_COMMENT_DISABLED'
export const SET_REPLY_COMMENT_DISABLED = 'SET_REPLY_COMMENT_DISABLED'
export const SET_EDIT_COMMENT_DISABLED = 'SET_EDIT_COMMENT_DISABLED'
export const SET_REPLIES_COLLAPSED = 'SET_REPLIES_COLLAPSED'
export const SET_CURRENT_REPLY = 'SET_CURRENT_REPLY'
export const ON_CHANGE_TRAINING_FORM = 'ON_CHANGE_TRAINING_FORM'
export const ON_CHANGE_TRAINING_TYPE = 'ON_CHANGE_TRAINING_TYPE'
export const SELECT_STORES = 'SELECT_STORES'
export const SET_TRAINING_INTRUCTORS = 'SET_TRAINING_INTRUCTORS'
export const ON_CHANGE_TRAINING_INTRUCTORS = 'ON_CHANGE_TRAINING_INTRUCTORS'
export const SELECT_USERS = 'SELECT_USERS'
export const SET_ASSIGN_EXPANDED = 'SET_ASSIGN_EXPANDED'
export const TRAINING_THUMBNAIL = 'TRAINING_THUMBNAIL'
export const SET_TRAINING_DATA = 'SET_TRAINING_DATA'
export const RESET_TRAINING_DATA = 'RESET_TRAINING_DATA'
export const SET_LOADING_TRAINING = 'SET_LOADING_TRAINING'
export const SET_COUNT = 'SET_COUNT'
export const TOGGLE_QUIZ_EXPIRATION = 'TOGGLE_QUIZ_EXPIRATION'
export const SET_QUESTIONS_PER_DAYS = 'SET_QUESTIONS_PER_DAYS'
export const SET_DAYS_PER_QUESTIONS = 'SET_DAYS_PER_QUESTIONS'
export const SET_QUIZ_START_DATE = 'SET_QUIZ_START_DATE'
export const SET_HIDE_FEEDBACK = 'SET_HIDE_FEEDBACK'
export const SET_IMAGE = 'SET_IMAGE'
export const SET_FULLSCREEN = 'SET_FULLSCREEN'
export const SET_COURSES_VIEW_PERMISSION = 'SET_COURSES_VIEW_PERMISSION'
export const SET_IN_VIEW_COURSE = 'SET_IN_VIEW_COURSE'
export const SET_CONTENT_QUIZ_PASS_PERCENTAGE =
  'SET_CONTENT_QUIZ_PASS_PERCENTAGE'

export const TOGGLE_CONTENT_QUIZ_PASS_PERCENTAGE =
  'TOGGLE_CONTENT_QUIZ_PASS_PERCENTAGE'

export const SET_COUNT_CONTENT_QUIZ = 'SET_COUNT_CONTENT_QUIZ'
export const TOGGLE_CONTENT_QUIZ_TIMER = 'TOGGLE_CONTENT_QUIZ_TIMER'
export const TOGGLE_CONTENT_QUIZ_RANDOMIZE_ORDER =
  'TOGGLE_CONTENT_QUIZ_RANDOMIZE_ORDER'

export const ON_CHANGE_CONTENT_QUESTION = 'ON_CHANGE_CONTENT_QUESTION'
export const CONTENT_QUESTION_ACTIVE_INDEX = 'CONTENT_QUESTION_ACTIVE_INDEX'
export const SET_CURRENT_CONTENT_QUIZ = 'SET_CURRENT_CONTENT_QUIZ'

export const ANSWER = 'ANSWER'

export const ACTIVE_QUESTION = 'ACTIVE_QUESTION'
export const SET_CONTENT_QUIZ_ID = 'SET_CONTENT_QUIZ_ID'

export const SET_SUBMITED_CONTENT_QUIZ = 'SET_SUBMITED_CONTENT_QUIZ'
export const SET_CONTENT_QUIZ_NAME = 'SET_CONTENT_QUIZ_NAME'
export const TOGGLE_CONTENT_QUIZ_PASSABLE = 'TOGGLE_CONTENT_QUIZ_PASSABLE'

export const SET_CONTENT_QUIZ_EDITING = 'SET_CONTENT_QUIZ_EDITING'
export const SET_CONTENT_QUIZ = 'SET_CONTENT_QUIZ'

export const SET_CONTENT_QUESTION_ACTIVE_INDEX =
  'SET_CONTENT_QUESTION_ACTIVE_INDEX'

export const UNDO_CONTENT_QUIZ = 'UNDO_CONTENT_QUIZ'

export const PRESENT_CONTENT_QUIZ = 'PRESENT_CONTENT_QUIZ'
export const SET_RETRY_CURRENT_CONTENT_QUIZ = 'SET_RETRY_CURRENT_CONTENT_QUIZ'

export const SET_NEW_CONTENT_QUIZ = 'SET_NEW_CONTENT_QUIZ'

export const SET_EXPIRATION_DATE = 'SET_EXPIRATION_DATE'
export const SET_EXPIRE_DATE = 'SET_EXPIRE_DATE'
export const SET_ACTIVE_EXPIRATION_DATE = 'SET_ACTIVE_EXPIRATION_DATE'
export const SET_EXPIRE_PERIOD = 'SET_EXPIRE_PERIOD'
export const SET_CHANGE_EXPIRATION_DATE = 'SET_CHANGE_EXPIRATION_DATE'
export const INCREASE_IFRAME_KEY = 'INCREASE_IFRAME_KEY'
export const RESET_EXPIRATION_DATE = 'RESET_EXPIRATION_DATE'
export const SET_LAST_PATHNAME = 'SET_LAST_PATHNAME'
export const SET_EMAIL_FREQUENCY = 'SET_EMAIL_FREQUENCY'
export const SET_ALL_LANGUAGES_PROMOTED = 'SET_ALL_LANGUAGES_PROMOTED'
export const SET_COURSE_PROMOTED = 'SET_COURSE_PROMOTED'
export const CLOSE_QUIZ_MODAL = 'CLOSE_QUIZ_MODAL'
export const SET_RESETTING_PROGRESS = 'SET_RESETTING_PROGRESS'
export const SET_TABLE_DATA = 'SET_TABLE_DATA'
export const SET_ENROLLMENT_TYPE = 'SET_ENROLLMENT_TYPE'
export const SET_NEW_ACCESS_CODE = 'SET_NEW_ACCESS_CODE'
export const SET_ENROLLMENT_PERIOD_TYPE = 'SET_ENROLLMENT_PERIOD_TYPE'
export const SET_ENROLLMENT_PERIOD = 'SET_ENROLLMENT_PERIOD'
export const SET_PRICE = 'SET_PRICE'
export const SET_FETCHED_ALL_COURSES = 'SET_FETCHED_ALL_COURSES'
export const SET_HAS_GIVEN_FEEDBACK = 'SET_HAS_GIVEN_FEEDBACK'
export const SET_COMPLETED_TERMS = 'SET_COMPLETED_TERMS'
